export default __webpack_public_path__ + "static/media/Dariusz Gajewicz.50d7b696.jpg";